import styled from 'styled-components';

import { palette } from '../../config/theme';

export const Highlight = styled.span`
  color: ${palette('primary')};
`;
